import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LicenseService } from 'app/core/services/license.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DomainService } from 'app/core/services/domain.service';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { CommBoxConfig } from 'app/core/components/workflow-new/common/communication-box/communication-box.component';

@Component({
  selector: 'itpx-redeem-new',
  templateUrl: './redeem-new.component.html',
  styleUrls: ['./redeem-new.component.css', '../login/login.component.css']
})
export class RedeemNewComponent extends LoadingPage implements OnInit {
  commBoxConfig: CommBoxConfig;
  private domain: any;
  private form: FormGroup;
  private redeemClick$ = new Subject<void>();
  private profile: any;

  constructor(
    private licenseService: LicenseService,
    private router: Router,
    private fb: FormBuilder,
    private domainService: DomainService,
    private profileService: ProfileService
  ) { super(); }

  ngOnInit() {
    this.loading();
    this.domain = this.domainService.getDomain();
    this.profile = this.profileService.getProfile().map(res => res.data).bindToLifecycle(this)
    .subscribe(data => { this.profile = data; this.prepareFormAndReady(); });
    
    this.redeemClick$.switchMap(_ => this.redeemVoucher()).neverError().bindToLifecycle(this)
    .subscribe(_ => this.router.navigate(['app']));
  }


  prepareFormAndReady() {
    this.form = this.fb.group({
      email: [{value: this.profile.username, disabled: true}],
      voucher: [null, Validators.required]
    });
    this.ready();
  }
  redeem() {
    this.redeemClick$.next();
  }

  redeemVoucher() {
    return this.licenseService.redeemVoucherSuppressError(this.form.get('voucher').value)
    .map(body => body.data)
      .catch((err: any) => {
        const e = err.json();
        this.commBoxConfig = {
          message: e.error.message.replace(e.error.code[0] + ' ', ''),
          level: 'err'
        };
        return Observable.empty();
      });
  }

  // handleData(data: any) {
  //   this.router.navigate(['app']);
  // }
}



// WEBPACK FOOTER //
// ./src/app/core/components/redeem-new/redeem-new.component.ts